export default {
      id: "instagram-usage",
      viewBox: "0 0 169.063 169.063",
      url: "../../assets/" + "sprite.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }